import {
    BaseLayer,
    BaseLayerFactory_3857,
    BaseLayerType
} from "esdm-map";
import { IBaseLayer } from "esdm-map/dist/baselayers/interfaces/IBaseLayer";
import { Tile } from "ol";
import TileLayer from "ol/layer/Tile";
import TileGrid from "ol/tilegrid/TileGrid";
import WMTS from 'ol/source/WMTS';
import WMTSTileGrid from 'ol/tilegrid/WMTS';
import TileWMS from 'ol/source/TileWMS';
import { ColchesterBaseLayers } from "../DefaultMapOptions";
import { get as getProjection } from 'ol/proj.js';
import { getTopLeft, getWidth } from 'ol/extent.js'


export class CustomClient_BaseLayerFactory_3857 extends BaseLayerFactory_3857 {

    public GetBaseLayerByType(baseLayerType: BaseLayerType, bingApiKey: string = "", esdmApiKey: string = ""): IBaseLayer {
        if (baseLayerType === ColchesterBaseLayers.OS) {
            return this.GetOS3857();
        }
        return super.GetBaseLayerByType(baseLayerType, bingApiKey, esdmApiKey);
    }


    private GetOS3857(): IBaseLayer {      
        let lyr = new TileLayer({
            visible: true,
            source: new WMTS({
                //url: "https://api.os.uk/maps/raster/v1/wmts?key=lRoEMFwvsGzbRdfWFOBA1iIGix1kqEUC&",
                url: "/api/OgcService/os",
                layer: "Road_3857",
                matrixSet: "EPSG:3857",
                format: "image/png",
                projection: "EPSG:3857",
                tileGrid: new WMTSTileGrid({                                        
                    origin: [-20037508.342787, 20037508.342787],
                    resolutions: [1222.9924523698928, 611.4962261850814, 305.7481130924087, 152.87405654633633, 76.43702827303586, 38.21851413651793, 19.109257068258966, 9.554628534129483, 4.777314267197037, 2.3886571335985134, 1.1943285666669667, 0.5971642834657753, 0.2985821416005962, 0.1492910708002979],
                    matrixIds: ["EPSG:3857:7", "EPSG:3857:8", "EPSG:3857:9", "EPSG:3857:10", "EPSG:3857:11", "EPSG:3857:12", "EPSG:3857:13", "EPSG:3857:14", "EPSG:3857:15", "EPSG:3857:16", "EPSG:3857:17", "EPSG:3857:18", "EPSG:3857:19", "EPSG:3857:20"]
                }),
                style: "default",                                
                crossOrigin: "Anonymous",
                attributions: `© Crown copyright and database rights ${new Date().getFullYear()} Ordnance Survey AC0000817586.`
            })
        });        
        return new BaseLayer("OS3857", "Ordnance Survey", lyr);
    }

}